import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useCookieConsent } from "@/hooks/useCookieConsent";
import { Button } from "@/components/ui/button";
import { CookieSettingsDialog } from "./CookieSettingsDialog";

export default function CookieConsent() {
  const { getConsentStatus, acceptAll, acceptNecessaryOnly, logConsentToAuditTrail } =
    useCookieConsent();
  const [visible, setVisible] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  useEffect(() => {
    const status = getConsentStatus();
    setVisible(status === null);
  }, [getConsentStatus]);

  const handleAcceptAll = () => {
    acceptAll();
    logConsentToAuditTrail(true, { necessary: true, analytics: true });
    setVisible(false);
  };

  const handleRejectAnalytics = () => {
    acceptNecessaryOnly();
    logConsentToAuditTrail(false, { necessary: true, analytics: false });
    setVisible(false);
  };

  const handleSettingsSaved = () => {
    setVisible(false);
    setSettingsOpen(false);
  };

  if (!visible) return null;

  return (
    <>
      <div
        className="fixed bottom-0 left-0 right-0 z-[9999] p-4 sm:p-6 animate-fade-up"
        role="dialog"
        aria-label="Cookie-Einstellungen"
      >
        <div className="max-w-2xl mx-auto bg-background rounded-2xl p-6 sm:p-8 border border-border shadow-2xl">
          <div className="mb-4">
            <p className="text-muted-foreground text-sm leading-relaxed">
              Wir verwenden Cookies, um unsere Website optimal zu gestalten und fortlaufend zu verbessern. Neben technisch notwendigen Cookies setzen wir solche zu Analyse- und Statistikzwecken ein. Du kannst selbst entscheiden, welche Kategorien du zulassen möchtest. Mehr dazu in unserer{" "}
              <Link to="/datenschutz" className="underline text-foreground hover:text-primary transition-colors">
                Datenschutzerklärung
              </Link>.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-2">
            <Button
              variant="default"
              size="sm"
              onClick={handleAcceptAll}
              className="order-1"
            >
              Alle akzeptieren
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={handleRejectAnalytics}
              className="order-3 sm:order-2"
            >
              Nur notwendige
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => setSettingsOpen(true)}
              className="order-2 sm:order-3"
            >
              Einstellungen
            </Button>
          </div>
        </div>
      </div>

      <CookieSettingsDialog
        open={settingsOpen}
        onOpenChange={setSettingsOpen}
        onSaved={handleSettingsSaved}
      />
    </>
  );
}
